<template>
  <div id="app" class="app">
    <router-view/>
  </div>
</template>
<script>
export default {
  name: 'App'
}
</script>
<style>
 @import './assets/style/main.css';
 @import './assets/style/common.css';
 @import './assets/style/elementUI.css';
 @import './assets/style/awesome/css/font-awesome.min.css';
 @import './assets/style/iconfont/iconfont.css';
 
</style>




// WEBPACK FOOTER //
// src/App.vue